/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslation } from '@axo/shared/i18n';
import { DataSharingStatus } from '@axo/shared/types';
import { Button } from '@axo/ui-core/components/Button';
import { Card } from '@axo/ui-core/components/Card';
import { Grid, Stack } from '@axo/ui-core/components/layout/item';
import { Message } from '@axo/ui-core/components/Message';
import { Modal } from '@axo/ui-core/components/Modal';
import { Spinner } from '@axo/ui-core/components/Spinner';
import { Text } from '@axo/ui-core/components/typography/Text';
import { useCallback } from 'react';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';
import { useESkat } from '../../../../ESkat';
import { ESkatLoginButton } from '../../../../ESkat/ESkatLoginButton';
import type { DenmarkFormData } from '../../../FormData.dk.types';

export const ESkatActions = () => {
  const { t } = useTranslation();

  const { onSubmit, dataSharingStatus } = useAxoFormContext<DenmarkFormData>();

  const { loading: fetchingData } = useESkat();

  const onManualInputClick = useCallback(() => {
    onSubmit({
      'Frontend/Flow': true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mandatoryESkat = dataSharingStatus === DataSharingStatus.Mandatory;

  return (
    <>
      <Modal open={fetchingData}>
        <Modal.Header feedbackState="info">
          <Modal.Title> {t('ESkat.loading_text')}</Modal.Title>
        </Modal.Header>

        <Stack>
          <Stack align="center">
            <Spinner size="xl" />

            <Text size="xs">{t('ESkat.loading_hint')}</Text>
          </Stack>
        </Stack>
      </Modal>

      <Card spacing={'medium'}>
        <Message variant="info" hasIcon>
          {t('ESkat.benefit')}
        </Message>

        <Grid columns={{ s: 1, m: 1, l: 1 }}>
          <ESkatLoginButton hasIcon>{t('ESkat.share')}</ESkatLoginButton>

          {!mandatoryESkat && (
            <Button
              variant="tertiary"
              onClick={onManualInputClick}
              data-testid="manual-flow-button"
            >
              {t('ESkat.manual_input')}
            </Button>
          )}
        </Grid>
      </Card>
    </>
  );
};
